<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'locaisCrud'"
          crudName="Locais"
          newText="Novo Local"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableDownloadPdf="true"
          :enableDownloadExcel="true"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="true"
          :enableActive="true"
          :enableReset="false"
          :enableSenhaPath="false"
          :dataForm="dataForm"
          :extra="extra"
          @derrubar="derrubar"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "locaisTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      extra: [
        {
          id: "1",
          name: "derrubar",
          title: "Derrubar sessão",
          class: "btn btn-crud view",
          icon: "fas fa-retweet",
        },
      ],
      columns: [
        "id",
        "nome",
        "setor_id",
        "usuario_logado",
        "login_logado",
        "actions",
      ],
      tableData: ["id", "nome", "setor_id", "usuario_logado", "login_logado"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "nome",
          "setor_id",
          "usuario_logado",
          "login_logado",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Nome",
          setor_id: "Setor",
          usuario_logado: "Usuário Logado",
          login_logado: "Login",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {
          setor_id: function (h, row, index) {
            return row.setor ? row.setor.nome : "Indisponível";
          },
          usuario_logado: function (h, row, index) {
            return row.usuario_logado ? row.usuario_logado.name : "Liberado";
          },
          login_logado: function (h, row, index) {
            return row.usuario_logado ? row.usuario_logado.login : "-";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["setor", "usuario_logado"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "locais/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    derrubar(row) {
      const self = this;

      var data = row.props.row;

      if (!data.usuario_logado) {
        swal("Ops", "Local não atribuído", "error");
      } else {
        const api = self.$store.state.api + "local/derrubar";

        swal({
          title: "Deseja desvincular o usuário?",
          text: "Essa operação não pode ser desfeita",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sim, deletar!",
          showLoaderOnConfirm: true,
          buttons: {
            catch: {
              text: "Não",
              value: "cancel",
              className: "btn-danger",
            },
            confirm: {
              text: "Sim",
              value: "confirm",
            },
          },
        }).then((value) => {
          switch (value) {
            case "cancel":
              swal("Cancelado", "O usuário não foi desvinculado!", "info");
              break;

            case "confirm":
              axios
                .post(api, data)
                .then((response) => {
                  window.location.reload();
                })
                .catch((error) => {
                  self.$message(null, error.response.data, "error");
                });
              break;
          }
        });
      }
    },
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome",
        setor_id: "setor[nome]",
        usuario_logado: "usuario_logado[name]",
        login_logado: "usuario_logado[login]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
